import sharedMutations from "@/store/utils/shared-mutations";
import { Message, Chat } from "@/models";

const PUSH_MESSAGE = (state, message) => {
  state.messages.allMessages.push(new Message(message));
};

const UNSHIFT_CONTACT_LIST = (state, params) => {
  const existingContact = state.contacts.allContacts.find(
    cont => cont.receiverId.Id === state.receiverProfile._id
  );
  if (!existingContact) {
    state.contacts.allContacts.unshift(
      new Chat({
        id: Number(new Date()).toString(),
        receiverId: {
          Id: state.receiverProfile._id,
          coachname:
            state.receiverProfile.coachname ||
            state.receiverProfile.athletename,
          image:
            state.receiverProfile.image || state.receiverProfile.profileImage
        },
        onModel: Chat.receiverType(state.receiverProfile.uniqueSlug),
        senderId: Chat.profileId(),
        senderType: Chat.senderType(),
        senderName: Chat.userName(),
        lastMessageId: {},
        contactIsIgnored: false,
        contactIsBlocked: params.contactIsBlocked,
        blockBy: params.blockBy,
      })
    );
  }
};

const SET_BLOCKED_TO_TRUE = (state, conversation) => {
  let conv = state.contacts.allContacts.find(
    conv => conv.id === conversation.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(conv),
    1,
    new Chat({ ...conv, contactIsBlocked: true, blockBy: Chat.profileId() })
  );
};

const SET_BLOCKED_TO_FALSE = (state, conversation) => {
  let conv = state.contacts.allContacts.find(
    conv => conv.id === conversation.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(conv),
    1,
    new Chat({ ...conv, contactIsBlocked: false, blockBy: null })
  );
};

const SET_IGNORED_TO_TRUE = (state, conversation) => {
  let conv = state.contacts.allContacts.find(
    conv => conv.id === conversation.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(conv),
    1,
    new Chat({ ...conv, contactIsIgnored: true, ignoreBy: Chat.profileId() })
  );
};

const SET_IGNORED_TO_FALSE = (state, conversation) => {
  let conv = state.contacts.allContacts.find(
    conv => conv.id === conversation.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(conv),
    1,
    new Chat({ ...conv, contactIsIgnored: false, ignoreBy: null })
  );
};

const SET_SAVED_TO_TRUE = (state, conversation) => {
  let conv = state.contacts.allContacts.find(
    conv => conv.id === conversation.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(conv),
    1,
    new Chat({ ...conv, isContactSaved: true })
  );
};

const SET_SAVED_TO_FALSE = (state, conversation) => {
  let conv = state.contacts.allContacts.find(
    conv => conv.id === conversation.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(conv),
    1,
    new Chat({ ...conv, isContactSaved: false })
  );
};

const INCREASE_CURRENT_MESSAGE_PAGE = state => {
  let tempPage = state.currentPage;
  for (;;) {
    tempPage++;
    if (!state.pageHistory.includes(tempPage)) break;
  }
  state.currentPage = tempPage;
};

const DECREASE_CURRENT_MESSAGE_PAGE = state => {
  if (state.currentPage === 1) return;
  let tempPage = state.currentPage;
  for (;;) {
    tempPage--;
    if (!state.pageHistory.includes(tempPage) || tempPage === 1) break;
  }
  state.currentPage = tempPage;
};

const RESET_STORE = state => {
  state.contactList = [];
  state.contacts = { ...state.contacts, allContacts: [], current: [] };
  state.contactListLoading = false;
  state.messages = { allMessages: [], current: [] };
  state.messagesLoading = false;
  state.connect = false;
  state.connectLoading = false;
  state.blockedUser = {};
  state.unblockedUser = {};
  state.blockedUserLoading = false;
  state.unblockedUserLoading = false;
  state.savedUser = {};
  state.savedUserLoading = false;
  state.searchedMessages = [];
  state.searchedMessagesLoading = false;
  state.currentPage = 1;
  state.pageHistory = [1];
  state.messagePageLoading = false;
  state.senderProfile = {};
  state.senderProfileLoading = false;
  state.contactListPage = 1;
  state.receiverProfile = {};
};

const SET_PAGE_HISTORY = (state, history) => {
  state.pageHistory = [...history];
};

const PUSH_PAGE_HISTORY = (state, data) => {
  state.pageHistory.push(data);
  state.pageHistory.sort();
};

const EMPTY_MESSAGES = state => {
  state.messages = { current: state.messages.current, allMessages: [] };
};

const DELETE_CONTACT_LOCALLY = (state, contact) => {
  const localContact = state.contacts.allContacts.find(
    cont => cont.id === contact.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(localContact),
    1
  );
};

const DELETE_CONTACT_BY_ID = (state, contactId) => {
  const contact = state.contacts.allContacts.find(
    cont => cont.id === contactId
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(contact),
    1
  );
};

const SET_READ_TO_TRUE = (state, conversation) => {
  const contact = state.contacts.allContacts.find(
    cont => cont.id === conversation.id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(contact),
    1,
    new Chat({ 
      ...contact, 
      isRead: true,
      allMessegeRead: true
    })
  );
};

const SET_READ_TO_FALSE = (state, message) => {
  const contact = state.contacts.allContacts.find(
    cont => cont.receiverId.Id === message.msgFrom
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(contact),
    1,
    new Chat({ ...contact, isRead: false })
  );
};

const CLEAR_SEARCHED_MESSAGES = state => {
  state.searchedMessages = [];
};

const INCREASE_CONTACT_LIST_PAGE = state => (state.contactListPage += 1);

const SET_CONTACT_LIST_PAGE = (state, pageNumber) => {
  state.contactListPage = pageNumber;
};

const CLEAR_CONTACT_LIST = state => {
  state.contacts = { ...state.contacts, allContacts: [], current: [] };
};

const UPDATE_CONTACT = (state, contact) => {
  const stateContact = state.contacts.allContacts.find(
    cont =>
      cont.id === contact._id || cont.receiverId.Id === contact.receiverId._id
  );
  if (!stateContact) {
    state.contacts.allContacts.unshift(new Chat({ ...contact }));
    return;
  }
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(stateContact),
    1
  );
  state.contacts.allContacts.unshift(new Chat({ ...contact }));
};

const SET_RECEIVER_PROFILE = (state, profile) => {
  state.receiverProfile = { ...profile };
};

const SET_NOTIFICATION_COUNT = (state, total) => {
  state.contacts = { ...state.contacts, unreadCount: total };
};

const DECREASE_NOTIFICATION_COUNT = state =>
  (state.contacts = {
    ...state.contacts,
    unreadCount: state.contacts.unreadCount - 1
  });

const DELETE_RECEIVER_PROFILE = state => (state.receiverProfile = {});

const CONDITIONALLY_SPLICE_CONTACT = (state, contact) => {
  if (!state.contacts.allContacts.find(cont => cont.id === contact._id)) return;

  const localContact = state.contacts.allContacts.find(
    cont => cont.id === contact._id
  );
  state.contacts.allContacts.splice(
    state.contacts.allContacts.indexOf(localContact),
    1,
    new Chat({ ...contact })
  );
};

const TOGGLE_USER_ONLINE_OFFLINE = (state, params) => {
  let { receiverId, status } = params;
  status = status === "online";
  const contact = state.contacts.allContacts.find(
    cont => cont.receiverId.Id === receiverId
  );
  if (contact) {
    let lastOnlineDate = contact.lastOnlineDate;
    if (!status) lastOnlineDate = new Date().toISOString();
    state.contacts.allContacts.splice(
      state.contacts.allContacts.indexOf(contact),
      1,
      new Chat({ ...contact, status, lastOnlineDate })
    );
  }
};

export default {
  ...sharedMutations,
  PUSH_MESSAGE,
  UNSHIFT_CONTACT_LIST,
  SET_BLOCKED_TO_TRUE,
  SET_BLOCKED_TO_FALSE,
  SET_IGNORED_TO_TRUE,
  SET_IGNORED_TO_FALSE,
  INCREASE_CURRENT_MESSAGE_PAGE,
  DECREASE_CURRENT_MESSAGE_PAGE,
  SET_PAGE_HISTORY,
  PUSH_PAGE_HISTORY,
  EMPTY_MESSAGES,
  DELETE_CONTACT_LOCALLY,
  SET_READ_TO_TRUE,
  CLEAR_SEARCHED_MESSAGES,
  SET_READ_TO_FALSE,
  INCREASE_CONTACT_LIST_PAGE,
  SET_CONTACT_LIST_PAGE,
  CLEAR_CONTACT_LIST,
  SET_SAVED_TO_TRUE,
  SET_SAVED_TO_FALSE,
  DELETE_CONTACT_BY_ID,
  UPDATE_CONTACT,
  SET_RECEIVER_PROFILE,
  SET_NOTIFICATION_COUNT,
  DECREASE_NOTIFICATION_COUNT,
  DELETE_RECEIVER_PROFILE,
  CONDITIONALLY_SPLICE_CONTACT,
  RESET_STORE,
  TOGGLE_USER_ONLINE_OFFLINE
};
